import React, { useState } from "react";
import { FloorsHeader } from "../../../../components/Floors/FloorsHeader/FloorsHeader";
import { useApolloClient, useQuery } from "@apollo/client";
import {
  FLOOR_FIELDS_FRAGMENT,
  FloorFields,
  GET_FLOOR,
  GetFloorResponse,
  GetFloorVariables,
} from "../../../../api/graphql/floors/floors";
import { RouteComponentProps } from "react-router-dom";
import { FloorPlan } from "../../../../components/Floors/FloorPlan/FloorPlan";
import { LoadingBox } from "../../../../components/shared/LoadingBox/LoadingBox";

import "../Floors.scss";

interface Props {
  id: string;
}

export const FloorSingle = ({
  match: {
    params: { id },
  },
}: RouteComponentProps<Props>) => {
  const client = useApolloClient();
  const [openMapSettings, setOpenMapSettings] = useState(false);

  const cachedFloorData = client.readFragment<FloorFields>({
    id: `Floor:${id}`,
    fragmentName: "FloorFields",
    fragment: FLOOR_FIELDS_FRAGMENT,
  });
  const { data, loading } = useQuery<GetFloorResponse, GetFloorVariables>(
    GET_FLOOR,
    {
      variables: { id },
      fetchPolicy: "cache-and-network",
    }
  );
  const floorData = data ? data.getFloor : cachedFloorData;

  if (!floorData && loading) {
    return <LoadingBox />;
  }

  if (!floorData) {
    return <div>Could not load floor data.</div>;
  }

  return (
    <>
      <FloorsHeader
        title={floorData.name}
        floorId={id}
        imageUrl={floorData.map?.url || ""}
        hasImage={!!floorData.map}
        handleOpenMapSettings={() => setOpenMapSettings((prev) => !prev)}
      />

      <FloorPlan data={floorData} openMapSettings={openMapSettings} />
    </>
  );
};
